export default "__VITE_ASSET__DUV2sePf__"